import React, { Suspense, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import FallbackLoader from "./components/FallbackLoader";
import "aos/dist/aos.css";
import AOS from "aos";
import ScrollToTop from "./components/ScrollToTop";

const Clients = React.lazy(() => import("./Pages/Clients/Clients"));
const Home = React.lazy(() => import("./Pages/Home/Home"));
const Placements = React.lazy(() => import("./Pages/Placements/Placements"));
const CourseDetails = React.lazy(() =>
  import("./Pages/CourseDetails/CourseDetailsPage")
);
// const DummyCourses = React.lazy(() =>
//   import("./Pages/CourseDetails/DummyCourses")
// );
const Courses = React.lazy(() => import("./Pages/Courses/Courses"));
const AITrainingPage = React.lazy(() =>
  import("./Pages/AITraining/AITrainingPage")
);
const ArticleDetailsPage = React.lazy(() =>
  import("./Pages/Articles/ArticleDetailsPage")
);
const SchedulePage = React.lazy(() => import("./Pages/Schedule/SchedulePage"));
const AboutUs = React.lazy(() => import("./Pages/AboutUs/AboutUs"));
const Page404 = React.lazy(() => import("./Pages/Page404/Page404"));
const Contact = React.lazy(() => import("./Pages/Contact/Contact"));
const PhotoGallery = React.lazy(() =>
  import("./Pages/PhotoGallery/PhotoGallery")
);
const SuccessStories = React.lazy(() =>
  import("./Pages/SucessStories/SuccessStoriesPage")
);
const OJT = React.lazy(() => import("./Pages/OJT/OJT"));

function App() {
  useEffect(() => {
    AOS.init({
      duration: 500, // animation duration
      once: true, // animation runs once only
      easing: "ease-in-out",
    });
  }, []);

  return (
    <Suspense fallback={<FallbackLoader />}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/placements" element={<Placements />} />
        <Route path="/on-job-training-and-placement-program-for-freshers" element={<OJT />} />
        <Route path="/ojt" element={<OJT />} />

        <Route path="/courses" element={<Courses />} />
        <Route path="/ai-training-in-pune" element={<AITrainingPage />} />
        <Route path="/articles/:slug" element={<ArticleDetailsPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/courses/:slug" element={<CourseDetails />} />
        <Route path="/courses/:slug/:id" element={<CourseDetails />} />
        {/* <Route path="/dummy-courses" element={<DummyCourses />} />
        <Route path="/dummy-courses/:id" element={<DummyCourses />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/photogallery" element={<PhotoGallery />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/successStories" element={<SuccessStories />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </Suspense>
  );
}

export default App;
